<template>
  <div class="jxgj-container" id="xmcbjs">
    <div class="mycontainer" style="margin-bottom: 0px">
      <el-form
        ref="queryForm"
        :model="listQuery"
        label-width="auto"
        :rules="rules"
        inline-message
      >
        <el-row :gutter="20">
          <el-col :span="5">
            <el-form-item label="时间类型" prop="sjlx">
              <el-select
                ref="sjlx"
                style="width: 100%"
                v-model="listQuery.sjlx"
                placeholder="全部"
                size="small"
                class="filter-item"
              >
                <el-option
                  v-for="item in lxList"
                  :key="item.key"
                  :label="item.value"
                  :value="item.key"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <!-- <el-form-item label="月份" prop="tjyf">
              <el-date-picker
                v-model="listQuery.tjyf"
                type="month"
                size="small"
                style="width: 100%"
                format="yyyy-MM"
                placeholder="选择月份"
                value-format="yyyyMM"
                :picker-options="pickerOptions"
              ></el-date-picker>
            </el-form-item> -->
            <el-form-item label="统计月份" prop="status">
              <el-date-picker
                v-model="time[0]"
                style="width: 48%"
                type="month"
                format="yyyy-MM"
                placeholder="选择月份"
                value-format="yyyyMM"
                :pickerOptions="pickerOptions"
                @change="onStartChange"
              ></el-date-picker
              ><span
                style="width: 4%; display: inline-block; text-align: center"
                >-</span
              >
              <el-date-picker
                v-model="time[1]"
                style="width: 48%"
                type="month"
                format="yyyy-MM"
                placeholder="选择月份"
                value-format="yyyyMM"
                :pickerOptions="pickerOptions"
                @change="onEndChange"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="部门" prop="bmbh">
              <el-select
                ref="bmbh"
                v-model="listQuery.bmbh"
                placeholder="所属部门"
                filterable
                size="small"
                style="width: 100%"
                class="filter-item"
                @change="handleChangeBm"
              >
                <el-option
                  v-for="item in bmList"
                  :key="item.bmbh"
                  :label="item.bmmc"
                  :value="item.bmbh"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="5">
            <el-form-item label="区域总监" prop="xmbh">
              <el-select
                ref="qyzj"
                v-model="listQuery.qyzj"
                placeholder="区域总监"
                clearable
                filterable
                size="small"
                style="width: 100%"
                class="filter-item"
                collapse-tags
                @change="handleChangeQyzj"
              >
                <el-option
                  v-for="item in areaDirectorList"
                  :key="item.ygbh"
                  :label="item.xm"
                  :value="item.ygbh"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="项目名称" prop="xmbh" style="width: 100%">
              <el-select
                ref="xmbh"
                v-model="listQuery.xmbh"
                placeholder="项目名称"
                clearable
                filterable
                size="small"
                style="width: 100%"
                class="filter-item"
                :multiple="true"
                collapse-tags
              >
                <el-option
                  v-for="item in xmList"
                  :key="item.xmbh"
                  :label="item.xmmc"
                  :value="item.xmbh"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="6">
            <el-form-item label="合同类型" prop="htlx">
              <el-select
                ref="htlx"
                v-model="listQuery.htlx"
                placeholder="合同类型"
                clearable
                filterable
                size="small"
                style="width: 100%"
                class="filter-item"
                collapse-tags
              >
                <el-option
                  v-for="item in htlx"
                  :key="item.htlx"
                  :label="item.htlxxmc"
                  :value="item.htlx"
                />
              </el-select>
            </el-form-item>
          </el-col> -->
          <el-col :span="6">
            <span style="margin-top: 4px; display: inline-block">
              <el-button
                type="primary"
                icon="el-icon-search"
                size="small"
                @click="getList"
                >查询</el-button
              >
              <el-button
                type="primary"
                icon="el-icon-download"
                size="small"
                @click="handleExport"
                style="margin-left: 15px"
                >导出</el-button
              >
            </span>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="">
      <el-table
        :max-height="height"
        v-loading="listLoading"
        :data="list"
        fit
        highlight-current-row
        :header-cell-style="tableHeaderColor"
        :default-sort="{ prop: 'date', order: 'descending' }"
        tooltip-effect="dark"
        :cell-class-name="myclass"
        ref="xmcbhsTable"
      >
        <el-table-column
          label="分公司"
          prop="bmmc"
          min-width="100px"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.bmmc }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="项目名称"
          prop="xmmc"
          min-width="200px"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span>{{ scope.row.xmmc }}</span>
          </template>
        </el-table-column>

        <el-table-column
          label="区域总监"
          prop="qyzj"
          :show-overflow-tooltip="true"
          min-width="80px"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.qyzj }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="客户姓名"
          prop="gxrxm"
          min-width="80px"
          align="center"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.gxrxm }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="客户角色"
          prop="gxrzw"
          min-width="160px"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span>{{ scope.row.gxrzw }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="绑定时间"
          prop="bdsj"
          min-width="160px"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span>{{ scope.row.bdsj }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="登录次数"
          prop="dlcs"
          min-width="120px"
          align="right"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{ scope.row.dlcs }}
          </template>
        </el-table-column>
        <el-table-column
          label="功能使用次数"
          prop="sycs"
          min-width="160px"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span>{{ scope.row.sycs }}</span>
          </template>
        </el-table-column>
        <template slot="empty">
          <div class="nodata">
            <img src="@/img/nodata.png" alt="" width="160" />
            <div>暂无数据</div>
          </div>
        </template>
      </el-table>
      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="listQuery.page"
        :limit.sync="listQuery.pageSize"
        @pagination="getList"
      >
      </pagination>
    </div>
  </div>
</template>
<script>
import Pagination from "@/components/Pagination"; // secondary package based on el-pagination
import { formatMomentDate, deepClone } from "@/utils/utils";

import {
  getAreaDirector,
  getBmxx,
  isAreaDirector,
  getHtlx,
} from "@/api/xmcbhs.js";
import { exportBindList, getBindList, getXmxx } from "@/api/hbyy.js";
import moment from "moment";
import "moment/locale/zh-cn";

export default {
  name: "jxgj",
  components: { Pagination },
  data() {
    return {
      height: 115,
      listQuery: {
        sjlx: "1",
        xmbh: [],
        bmbh: "",
        tjyf: moment().format("YYYYMM"),
        qyzj: "",
        htlx: "",
        qsrq: "",
        jsrq: "",
        page: 1,
        pageSize: 10,
      },
      lxList: [
        { key: "1", value: "绑定时间" },
        { key: "2", value: "登录时间" },
        { key: "3", value: "操作时间" },
      ],

      total: 0,
      bmList: [],
      xmList: [],
      htlx: [],
      areaDirectorList: [],
      time: [moment().format("YYYYMM"), moment().format("YYYYMM")],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },

      list: [],
      listLoading: true,
      rules: {
        tjyf: [{ required: false, message: "请选择月份", trigger: "change" }],
      },
    };
  },
  created() {
    // login().then((res) => {
    //   localStorage.setItem("token", res.token);

    getHtlx().then((res) => {
      if (res.code == 0) {
        this.htlx = res.data;
      }
    });
    isAreaDirector().then((res) => {
      if (res.code == 0) {
        if (res.data && res.data != "null") {
          this.listQuery.qyzj = res.data;
        }
        getBmxx().then((res2) => {
          if (res2.code == 0) {
            this.bmList = res2.data;
            if (this.bmList && this.bmList.length > 1) {
              this.bmList.unshift({ bmbh: "", bmmc: "全部" });
            }
            this.listQuery.bmbh = this.bmList[0].bmbh;
            getAreaDirector(this.listQuery.bmbh).then((res3) => {
              if (res3.code == 0) {
                this.areaDirectorList = res3.data;
                const qyzj = this.listQuery.qyzj;
                getXmxx(this.listQuery.bmbh, qyzj).then((res4) => {
                  if (res4.code == 0) {
                    this.xmList = res4.data;
                    this.getList();
                  }
                });
              }
            });
          }
        });
      }
      // });
    });
  },
  methods: {
    onStartChange(start) {
      // 开始日期晚于结束日期时，结束日期自动设置为开始日期
      const isAfter = moment(start).isAfter(this.time[1]);
      if (isAfter) {
        this.$set(this.time, 1, start);
      }
    },
    onEndChange(end) {
      // 结束日期早于开始日期时，开始日期自动设置为结束日期
      const isBefore = moment(end).isBefore(this.time[0]);
      if (isBefore) {
        // 赋值需要回显,需使用一下写法
        this.$set(this.time, 0, end);
        //错误写法
        // this.time[0] = end;
        // 语法
        // this.$set(原数组, 索引值, 需要赋的值);
      }
    },
    //月份第一天时间戳
    getCurrentYearFirst() {
      var date = new Date();
      let nowYear = date.getFullYear();
      var date1 = new Date(nowYear, 0, 1);
      return moment(date1).format("YYYYMM");
    },
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #f2f2f2;";
      }
    },
    getList() {
      this.listLoading = true;
      if (this.time && this.time.length == 2) {
        this.listQuery.qsrq = this.time[0];
        this.listQuery.jsrq = this.time[1];
      }
      const params = { ...this.listQuery };
      if (params.xmbh instanceof Array) {
        params.xmbh = params.xmbh.join(",");
      }
      getBindList(params).then((res) => {
        if (res.code == 0) {
          this.$nextTick(() => {
            this.listLoading = false;
            this.list = res.data;
            const docH = document.documentElement.clientHeight;
            const mycontainerH =
              document.querySelector(".mycontainer").clientHeight;
            this.height = docH - mycontainerH - 95;
            this.total = res.count;
            this.$nextTick(() => {
              this.$refs.xmcbhsTable.bodyWrapper.scrollTop = 0;
            });
          });
        }
      });
    },

    handleChangeBm(e) {
      // 部门
      this.listQuery.bmbh = e;
      this.listQuery.xmbh = [];
      this.listQuery.qyzj = [];
      getAreaDirector(this.listQuery.bmbh).then((res3) => {
        if (res3.code == 0) {
          this.areaDirectorList = res3.data;
        }
      });
      getXmxx(this.listQuery.bmbh, "").then((res4) => {
        if (res4.code == 0) {
          this.xmList = res4.data;
        }
      });
    },
    handleChangeQyzj(e) {
      //区域总监select框
      const qyzj = e;
      this.listQuery.xmbh = [];
      getXmxx(this.listQuery.bmbh, qyzj).then((res) => {
        if (res.code == 0) {
          this.xmList = res.data;
        }
      });
    },

    //导出
    handleExport() {
      if (this.time && this.time.length == 2) {
        this.listQuery.qsrq = this.time[0];
        this.listQuery.jsrq = this.time[1];
      }
      const params = deepClone(this.listQuery);
      if (params.qyzj instanceof Array) {
        params.qyzj = params.qyzj.join(",");
      }
      if (params.xmbh instanceof Array) {
        params.xmbh = params.xmbh.join(",");
      }
      exportBindList(params).then((res) => {
        if (res.code === 0) {
          const fileName = res.msg.substr(
            res.msg.indexOf("_") + 1,
            res.msg.length
          );
          const filePath = res.msg;
          const url =
            window.g.apiUrl +
            "system/downloadFile?fileName=" +
            fileName +
            "&filePath=" +
            filePath;
          // 组装a标签
          const elink = document.createElement("a");
          // 设置下载文件名
          elink.download = fileName;
          elink.style.display = "none";
          elink.href = url;
          document.body.appendChild(elink);
          elink.click();
          document.body.removeChild(elink);
        } else {
          this.$message({
            showClose: true,
            message: res.msg,
            type: "error",
          });
        }
      });
    },
    myclass({ row, column, rowIndex, columnIndex }) {
      if (columnIndex == 12) {
        if (row.sjlrl < 0) {
          return "red";
        }
      }
      if (columnIndex == 13) {
        if (row.yslrl < 0) {
          return "red";
        }
      }
      if (columnIndex == 14) {
        if (row.dbpcz > 0) {
          return "red";
        }
      }
      if (columnIndex == 15) {
        if (row.dbpcl > 0) {
          return "red";
        }
      }
    },
  },
};
</script>
<style lang="less" scoped>
.jxgj-container {
  padding: 20px;
  box-sizing: border-box;
  height: 100%;
  min-width: 1100px;
}
.flex-button {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 5%;
}
.choice-box {
  border: 1px solid;
  border-color: #cccc;
  display: auto;
}
.app-container {
  padding: 10px;
}
.mycontainer {
  padding: 10px;
  background-color: #fff;
  border-radius: 6px;
}
.mycontainer .el-form-item {
  margin-bottom: 5px;
}
.filter-container {
  background-color: #fff;
  padding: 0;
}
.filter-container .filter-item {
  margin-bottom: 0;
}
.search-container {
  border: 0;
}
.btn-container {
  padding-top: 0px;
  margin-top: 10px;
  background-color: #f2f2f2;
  border-top: #e2e2e2 1px solid;
  border-left: #e2e2e2 1px solid;
  border-right: #e2e2e2 1px solid;
}
.dialog-footer {
  text-align: center;
}
.dialog-header {
  background-color: #f2f2f2;
  margin: 5px 5px;
}
.btn {
  display: block;
  margin: 10px 10px;
  width: 120px;
  height: 40px;
  font-size: 14px;
  line-height: 40px;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.08);
  cursor: pointer;
}
.avatar {
  display: block;
  width: 60px;
  margin: 10px 10px;
}
.el-button + .el-button {
  margin-left: 0px;
}
.el-input__inner {
  width: 100%;
}

.flex-container {
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}
.flex-item1 {
  width: 40%;
  margin: 1%;
  min-height: 203.69px;
}
.flex-item2 {
  width: 80px;
  height: 70px;
}
.flex-item3 {
  width: 40%;
  margin: 1%;
  min-height: 203.69px;
}
.el-table__row > td {
  border: none;
}
.el-table::before {
  height: 0px;
}
.el-table th.is-leaf,
.el-table td {
  border-bottom: 0px;
}

::v-deep .el-dialog {
  width: 64%;
}
::v-deep .el-transfer-panel {
  width: 263px;
}
.pagination-container {
  border: none;
}
::v-deep #save-form .el-form-item__label {
  width: 160px !important;
}
::v-deep #save-form .el-form-item__content {
  margin-left: 160px !important;
}
::v-deep #save-form .el-select {
  width: 100% !important;
}
::v-deep #xmcbjs .el-input__inner {
  height: 32px !important;
  line-height: 32px;
}
</style>
